export const phoneToObject = (phone: string) => {
	const phoneElements = phone.split('-');
	return { phone: phoneElements[1], code: phoneElements[0] };
};
